module.exports = __webpack_public_path__ + "static/media/van_lanschot.21c9cc1a.png";